import React from "react"
import { Pressable as GluestackPressable } from "./gluestack/pressable"

export interface PressableProps
  extends React.ComponentProps<typeof GluestackPressable> {
  className?: string
}

export const Pressable = ({
  children,
  className,
  ...props
}: PressableProps) => {
  return (
    <GluestackPressable className={className} {...props}>
      {children}
    </GluestackPressable>
  )
}
